/**
 * `@whittlelabs/loom/runtime` — the Shuttle-side surface of Loom's strategy
 * contracts. A Shuttle executor imports this to read the shuttle-strategy header
 * and interpret a strategy's payload (ADR 0005). Pulls in no authoring/builder code.
 */

export type {
  GitWorkspace,
  WorkspaceOverlay,
  PromptExecutionRendering,
  PromptExecutionSpec,
  PromptExecutionUsage,
  PromptExecutionWorkspace,
} from './types';
export {
  readPromptExecutionSpec,
  renderPromptExecution,
  renderTemplate,
  pickProviderHints,
} from './prompt-execution';
export type { RenderedPromptExecution } from './prompt-execution';
export {
  SHUTTLE_STRATEGY_LABEL,
  PROMPT_EXECUTION_STRATEGY,
  shuttleStrategyInput,
  readShuttleStrategy,
} from './strategy';
export { validateAgainstSchema } from './validate';
export type { SchemaValidationResult } from './validate';
